<template>
  <div>
    <MasterLayout>
      <div class="dashboard_first_row" style="margin-top: 139px">
        <div class="ep-card mt-5">
          <div class="card-body text-center mx-0">
            <div v-if="status == 'successful'">
              <img src="@/assets/img/Group 3000.svg" alt="icon" width="100" />
              <h4 class="mt-5 primary-color">
                {{ $t("text.cInvoice.success.success") }}
              </h4>
            </div>
            <div v-if="status == 'failed'">
              <img src="@/assets/img/failure icon.png" alt="icon" width="100" />
              <h4 class="gold-color my-4">
                {{ $t("text.cInvoice.success.error1") }}
              </h4>
              <p>{{ $t("text.cInvoice.success.error2") }}</p>
            </div>
            <div class=""></div>
            <div class="py-3">
              <router-link
                :to="{
                  name: 'set-recurring-invoice',
                  query: { companyId: this.$route.query.companyId },
                }"
                class="primary-color"
                >{{ $t("text.cInvoice.success.continue") }}</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </MasterLayout>
  </div>
</template>
<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";

import Jquery from "jquery";
let $ = Jquery;

export default {
  title: "Success Page:: Epump Portal",
  components: {
    MasterLayout,
  },
  data() {
    return {
      trx_ref: null,
      status: null,
      message: null,
      company: null,
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
  },
  mounted() {
    this.trx_ref = this.$route.query.reference;
    this.status = this.$route.query.status.toLowerCase();
    this.message = this.$route.query.message;

    if (this.status == "successful") {
      this.confirmSetupPayment();
    }
  },
  methods: {
    confirmSetupPayment() {
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/DDConfirmed/${this.trx_ref}/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          {},
          configObject.authConfig()
        )
        .then((res) => {})
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.statusDescription,
            type: "error",
            duration: 3000,
          });
        });
    },
  },
};
</script>
